import * as React from 'react';

import {QUERY_STUDENT_FAVORITES} from '../studentQueries';
import {StudentTheme} from '../studentTheme';

import {TargetListScreen} from './TargetListScreen';

export const FavoritesScreen: React.FC<{theme: StudentTheme}> = ({theme}) => (
  <TargetListScreen
    theme={theme}
    query={QUERY_STUDENT_FAVORITES}
    campo="favorites"
    vazio="Você ainda não favoritou nada."
    erro="Não foi possível carregar os favoritos."
  />
);
